import PropertyComparison from "@landingClient/pages/PropertyComparison";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/assessments/$assessmentId/$comparisonId",
)({
  component: PropertyComparison,
});
